import React from "react";
import { View, StyleSheet, Platform, TouchableOpacity } from "react-native";
import { Text } from "@/app/components/Text";
import { colors } from "@/app/constants/styles";
import { useVersionCheck } from "@/app/hooks/useVersionCheck";

export function VersionUpdateBanner() {
  const { isUpdateAvailable, refresh } = useVersionCheck();

  if (Platform.OS !== "web" || !isUpdateAvailable) {
    return null;
  }

  return (
    <View style={styles.container}>
      <Text style={styles.text}>A new version is available.</Text>
      <TouchableOpacity
        onPress={refresh}
        style={styles.button}
        accessibilityRole="button"
        accessibilityLabel="Refresh Now"
      >
        <Text style={styles.buttonText}>Refresh Now</Text>
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: colors.casablanca,
    paddingVertical: 8,
    paddingHorizontal: 16,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: 12,
  },
  text: {
    color: colors.cedar,
    fontWeight: "500",
  },
  button: {
    backgroundColor: colors.cedar,
    paddingVertical: 6,
    paddingHorizontal: 12,
    borderRadius: 4,
  },
  buttonText: {
    color: colors.white,
    fontWeight: "600",
  },
});
